const SET_EATERIES = 'ts/StoryEditor/SET_EATERIES';
const SET_STORY = 'ts/StoryEditor/SET_STORY';
const SET_IS_SAVING = 'ts/StoryEditor/SET_IS_SAVING';
const SET_EDITED_SLUG = 'ts/StoryEditor/SET_EDITED_SLUG';
const SET_IS_DONE = 'ts/StoryEditor/SET_IS_DONE';

export default {
  SET_EATERIES,
  SET_STORY,
  SET_IS_SAVING,
  SET_EDITED_SLUG,
  SET_IS_DONE
};
